var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"master scrollable"},[_c('TopBar',{attrs:{"back":"/plus","title":"Conditions générales de ventes"}}),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"cgv-content",domProps:{"innerHTML":_vm._s(_vm.cgv_content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }